module.exports = __webpack_public_path__ + "static/media/content_2.dca3a388.png";